import { isSkipCrystallize } from 'next-common';
import { IVehiclePageProps } from '../../interfaces';
import { IUseVehicleResponse } from '../useVehicle';
import { useEffect, useState } from 'react';
import { useClientLazyQuery } from '../useClientLazyQuery';
import { NEXT_ENTITY } from '@common/interfaces/entity';

export const useClientVehicleDataByPimCode = (props: IVehiclePageProps): IUseVehicleResponse => {
  const { data, loading } = useVehilceDataFromPimQuery(props);
  return { vehicle: data || null, useVehicleLoading: loading };
};

const isValidCall = (props: IVehiclePageProps): boolean => {
  let allowAPIcall = null;
  const isSkipPimCall = isSkipCrystallize(props.configuration, props.order);
  if (props.orderId && props.pimCode) {
    if (props.source) {
      if (!isSkipPimCall) allowAPIcall = true;
      else {
        allowAPIcall = false;
      }
    }
  }
  return allowAPIcall;
};

const useVehilceDataFromPimQuery = (props: IVehiclePageProps) => {
  const [isloading, setIsLoading] = useState(true);

  const getVehicleDatafromPim = async () => {
    if (isValidCall(props)) {
      setIsLoading(true);
      await vehicleDataFromPim();
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getVehicleDatafromPim();
  }, [props.orderId, props.source, props.configuration, props.serialNo, props.make, props.pimCode]);

  const [vehicleDataFromPim, { data }] = useClientLazyQuery(NEXT_ENTITY.VEHICLE_CONFIGURATION, {
    variables: { pimCode: props?.pimCode },
    nextOptions: { revalidate: 60 },
  });
  return { data: data, loading: isloading };
};
